module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (268).b478b2bd.jpg";